import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'; // eslint-disable-line
import constants from '../../constants';

// eslint-disable-next-line react/prefer-stateless-function
class ValidatedControl extends Component {
    render() {
        let {
            containerClass,
            hasError,
            errorMessage,
            hasWarning,
            warningMessage,
            hasSuccess,
            successMessage,
            hasInfo,
            infoMessage,
        } = this.props;

        const id = this.props.id ? this.props.id : containerClass;
        containerClass = this.props.isFocused ? (`${containerClass} is-focused`) : containerClass;
        if (hasError) {
            containerClass += ' has-error';
        } else if (hasSuccess) {
            containerClass += ' has-success';
        } else if (hasWarning) {
            containerClass += ' has-warning';
        } else if (hasInfo) {
            containerClass += ' has-info';
        }
        let underText = null;
        if (hasError) {
            if (errorMessage) {
                underText = (
                    <div className="alert-text error">
                        <div className="alert-icon-holder">
                            <FontAwesomeIcon icon={['far', 'exclamation-circle']} color={constants.StyleColors.error2} size="sm" />
                        </div>
                        <p className="error">{errorMessage}</p>
                    </div>
                );
            }
        } else if (hasWarning) {
            if (warningMessage) {
                underText = (
                    <div className="alert-text warning">
                        <div className="alert-icon-holder">
                            <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} color={constants.StyleColors.warningDark} size="sm" />
                        </div>
                        <p className="warning">{warningMessage}</p>
                    </div>
                );
            }
        } else if (hasInfo) {
            if (infoMessage) {
                underText = (
                    <div className="alert-text info">
                        <div className="alert-icon-holder">
                            <FontAwesomeIcon icon={['fas', 'info-circle']} color={constants.StyleColors.grey35} size="sm" />
                        </div>
                        <p className="info">{infoMessage}</p>
                    </div>
                );
            }
        } else if (hasSuccess) {
            if (successMessage) {
                underText = (
                    <div className="alert-text success">
                        <div className="alert-icon-holder">
                            <FontAwesomeIcon icon={['far', 'check']} color={constants.StyleColors.successDark} size="sm" />
                        </div>
                        <p className="success">{successMessage}</p>
                    </div>
                );
            }
        }

        return (
            <div className={`form-control ${containerClass}`} data-qa={`wrapper-for-${id}`}>
                <div className="input-wrapper">
                    {this.props.children}
                </div>
                {underText}
            </div>
        );
    }
}

export default ValidatedControl;
